import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
import type { SvgIconProps } from "@mui/material/SvgIcon";

const PersonIcon = (props: SvgIconProps) => (
  <PersonOutlineOutlinedIcon {...props} fontSize="small" />
);

export default PersonIcon;
